export default "__VITE_ASSET__CvfetpXv__"